import InternalBookingCardBase from '../common/InternalBookingCardBase';
import { extractUpgradeSymbols } from '../../../../util/upgradeSymbolsHelper';

function BookingCardPixelv2({
  booking,
  handleOpenModal,
  renderAvailableSlots,
  rowHeight,
  onBookingShift,
  entertainment,
  onDragStart,
  onDragActivated,
  onDragEnd,
  availableShiftTimes,
  isShiftable,
}) {
  const color = '#ffffff';

  const upgradeSymbols = extractUpgradeSymbols(booking);

  const handleCardClick = (bookingId, color) => {
    handleOpenModal(bookingId, color);
  };

  return (
    <InternalBookingCardBase
      booking={booking}
      getParticipantCount={bk => bk.participantCount}
      onCardClick={handleCardClick}
      renderAvailableSlots={renderAvailableSlots}
      rowHeight={rowHeight}
      onBookingShift={onBookingShift}
      entertainment={entertainment}
      onDragStart={onDragStart}
      onDragActivated={onDragActivated}
      onDragEnd={onDragEnd}
      availableShiftTimes={availableShiftTimes}
      isShiftable={isShiftable}
      iconProps={{
        upgrades: upgradeSymbols,
        manualUpgrades: [],
        participantCount: booking.participantCount,
        slotMode: false,
        color,
      }}
      color={color}
    />
  );
}

export default BookingCardPixelv2;
